/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      redirect: '/login',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/pre-pulse/my-stuff',
          name: 'My Stuff Pre-Pulse',
          component: () => import('./views/pre-pulse/MyStuff.vue')
        },
        {
          path: '/pre-pulse/claim-auto',
          name: 'Claim Auto Pre-Pulse',
          component: () => import('./views/pre-pulse/ClaimAuto.vue')
        },
        {
          path: '/pulse/my-stuff',
          name: 'My Stuff Pulse',
          component: () => import('./views/pulse/MyStuff.vue')
        },
        {
          path: '/pulse/claim-auto',
          name: 'Claim Auto Pulse',
          component: () => import('./views/pulse/ClaimAuto.vue')
        },
        {
          path: '/pulse/search',
          name: 'Search Pulse',
          component: () => import('./views/pulse/Search.vue')
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/Login.vue')
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('@/views/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/login'
    }
  ]
})



router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
